import { FormProvider } from 'forms';
import React from 'react';
import RevisePayWizard from './RevisePayWizard';

export const RevisePay = () => {
  return (
    <FormProvider>
      <RevisePayWizard />
    </FormProvider>
  );
};
